export default __webpack_public_path__ + "static/media/button-img-toggle.4b2390ce.svg";